import { fetchWrapper } from "@/helpers";

const BASE_URL = `${import.meta.env.VITE_API_URL}`;

const fetchBootstrap = async (distributionId, participantTimepointId) => {
  return await fetchWrapper.get(
    `${BASE_URL}/${distributionId}/pt/${participantTimepointId}/bootstrap`,
  );
};

export const bootstrapService = {
  fetchBootstrap,
};
